import {
  STATUS_ERROR,
  STATUS_LOADING,
  STATUS_NOT_REQUESTED,
  STATUS_SUCCESS,
} from 'const';
import {
  GET_HR_DATA_ERROR,
  GET_HR_DATA_REQUEST,
  GET_HR_DATA_SUCCESS,
  INIT_HR_DATA,
} from 'modules/HRPage/actions';

const initialState = {
  totalCostData: [],
  totalHoursData: [],
  turnover: { datasets: {} },
  lastUpdated: '',
  error: '',
  status: STATUS_NOT_REQUESTED,
};

export const HRPage = (state = initialState, action) => {
  switch (action.type) {
    case INIT_HR_DATA:
      return initialState;

    case GET_HR_DATA_REQUEST:
      return {
        ...state,
        status: STATUS_LOADING,
      };

    case GET_HR_DATA_SUCCESS: {
      const { totalcost, totalheures, turnover, lastUpdated } = action.payload;
      return {
        ...state,
        totalCostData: totalcost,
        totalHoursData: totalheures,
        turnover,
        lastUpdated,
        status: STATUS_SUCCESS,
      };
    }

    case GET_HR_DATA_ERROR: {
      const { error } = action.payload;
      return {
        ...state,
        status: STATUS_ERROR,
        error,
        totalCostData: [],
        totalHoursData: [],
        turnover: { datasets: {} },
      };
    }

    default:
      return state;
  }
};
